import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { InboxesStore } from 'pages/settings/pages/inboxes/store/inboxesStore'
import { useSettingsContext } from 'pages/settings/context/settingsContext'

export const InboxesViewContext = createContext<InboxesStore | null>(null)

export const useInboxesViewContext = () => {
  const context = useContext(InboxesViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with InboxesViewContext')

  return context
}

export const InboxesViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const settingsContext = useSettingsContext()
  const store = useMemo(() => new InboxesStore(settingsContext, entities), [])

  useEffect(() => {
    void store.init()
  }, [])

  return <InboxesViewContext.Provider value={store}>{children}</InboxesViewContext.Provider>
}
